import { Component, Input } from '@angular/core';
import { IconSize } from '../../core-data-model/IconSize';

@Component({
    selector: 'placard-icon',
    template: `
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            attr.width="{{ iconSize }}"
            attr.height="{{ iconSize }}"
            version="1.1"
        >
            <defs>
                <circle
                    class="svgWrapperShape"
                    id="pl-path-1"
                    cx="53"
                    cy="53"
                    r="53"
                />
                <polygon
                    id="pl-path-3"
                    points="5.56053812e-05 0 61.8887892 0 61.8887892 43.9999722 5.56053812e-05 43.9999722"
                />
            </defs>
            <g
                id="pl-Person-Page-"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
            >
                <g
                    id="pl-B-Person-page--more-people-added-"
                    transform="translate(-943.000000, -1614.000000)"
                >
                    <g
                        id="pl-Group-5"
                        transform="translate(946.000000, 1617.000000)"
                    >
                        <g id="pl-Screen-Shot-2019-01-14-at-5.33.33-PM">
                            <mask id="pl-mask-2" fill="white">
                                <use xlink:href="#pl-path-1" />
                            </mask>
                            <use
                                id="pl-Mask"
                                stroke="#0092C8"
                                stroke-width="4.4"
                                fill="#F3FBFE"
                                fill-rule="nonzero"
                                xlink:href="#pl-path-1"
                            />
                        </g>
                        <g
                            id="pl-Group-18"
                            transform="translate(20.000000, 32.000000)"
                        >
                            <g id="pl-Group-3">
                                <mask id="pl-mask-4" fill="white">
                                    <use xlink:href="#pl-path-3" />
                                </mask>
                                <g id="pl-Clip-2" />
                                <path
                                    d="M11.0933291,40.6303519 L58.4969166,40.6303519 L58.4969166,3.39744051 L3.36418117,3.39744051 L3.36418117,32.8885797 L11.0933291,40.6303519 Z M59.1363785,43.9999722 L9.70319462,43.9999722 L5.56053812e-05,34.2809848 L5.56053812e-05,2.72908608 C5.56053812e-05,1.25313671 1.22337399,-2.78481013e-05 2.72471928,-2.78481013e-05 L59.1641812,-2.78481013e-05 C60.6377238,-2.78481013e-05 61.8888448,1.22528861 61.8888448,2.72908608 L61.8888448,41.2987063 C61.8610422,42.8025038 60.6377238,43.9999722 59.1363785,43.9999722 L59.1363785,43.9999722 Z"
                                    id="pl-Fill-1"
                                    fill="#3D1C70"
                                    mask="url(#pl-mask-4)"
                                />
                            </g>
                            <path
                                d="M42.3991865,9.13414937 C44.4107112,9.13414937 46.041339,10.7674405 46.041339,12.7822506 C46.041339,14.7970608 44.4107112,16.4303519 42.3991865,16.4303519 C40.3876619,16.4303519 38.7570341,14.7970608 38.7570341,12.7822506 C38.7570341,10.7674405 40.3876619,9.13414937 42.3991865,9.13414937 Z"
                                id="pl-Stroke-4"
                                stroke="#3D1C70"
                                stroke-width="2.24"
                            />
                            <path
                                d="M25.8565857,13.7848101 C27.8681103,13.7848101 29.4987381,15.4181013 29.4987381,17.4329114 C29.4987381,19.4477215 27.8681103,21.0810127 25.8565857,21.0810127 C23.845061,21.0810127 22.2144332,19.4477215 22.2144332,17.4329114 C22.2144332,15.4181013 23.845061,13.7848101 25.8565857,13.7848101 Z"
                                id="pl-Stroke-6"
                                stroke="#3D1C70"
                                stroke-width="2.24"
                            />
                            <path
                                d="M16.8762332,22.501238 C18.8877578,22.501238 20.5183857,24.1345291 20.5183857,26.1493392 C20.5183857,28.1641494 18.8877578,29.7974405 16.8762332,29.7974405 C14.8647085,29.7974405 13.2340807,28.1641494 13.2340807,26.1493392 C13.2340807,24.1345291 14.8647085,22.501238 16.8762332,22.501238 Z"
                                id="pl-Stroke-8"
                                stroke="#3D1C70"
                                stroke-width="2.24"
                            />
                            <path
                                d="M41.3147704,28.3493392 C43.3262951,28.3493392 44.9569229,29.9826304 44.9569229,31.9974405 C44.9569229,34.0122506 43.3262951,35.6455418 41.3147704,35.6455418 C39.3032457,35.6455418 37.6726179,34.0122506 37.6726179,31.9974405 C37.6726179,29.9826304 39.3032457,28.3493392 41.3147704,28.3493392 Z"
                                id="pl-Stroke-10"
                                stroke="#3D1C70"
                                stroke-width="2.24"
                            />
                            <path
                                d="M29.5542879,15.7063013 L38.534557,13.6455418"
                                id="pl-Stroke-12"
                                stroke="#3D1C70"
                                stroke-width="2.24"
                            />
                            <path
                                d="M19.2951229,24.0328835 L23.4377238,19.7164278"
                                id="pl-Stroke-14"
                                stroke="#3D1C70"
                                stroke-width="2.24"
                            />
                            <path
                                d="M20.6017659,27.2632633 L37.6448152,31.3569342"
                                id="pl-Stroke-16"
                                stroke="#3D1C70"
                                stroke-width="2.24"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    `,
    standalone: false
})
export class PlacardIconComponent {
    @Input()
    iconSize: IconSize;
}
